var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRainbow = function SvgIconRainbow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 6.25a9.875 9.875 0 0 0-9.875 9.875v.75a1 1 0 1 1-2 0v-.75a11.875 11.875 0 0 1 23.75 0v.75a1 1 0 1 1-2 0v-.75A9.875 9.875 0 0 0 12 6.25m-2.298 7.952A3.25 3.25 0 0 1 15.25 16.5v.375a1 1 0 1 1-2 0V16.5a1.25 1.25 0 0 0-2.5 0v.375a1 1 0 1 1-2 0V16.5c0-.862.342-1.689.952-2.298M12 8.75a7.75 7.75 0 0 0-7.75 7.75v.375a1 1 0 1 0 2 0V16.5a5.75 5.75 0 0 1 11.5 0v.375a1 1 0 1 0 2 0V16.5A7.75 7.75 0 0 0 12 8.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconRainbow;